import React, { createContext, useState } from "react";
import clickSoundFile from "../assets/sounds/finger-snap.mp3";
import successSoundFile from "../assets/sounds/hero_decorative-celebration-02.mp3";
import errorSoundFile from "../assets/sounds/alert_error-01.mp3";
import UIfx from "uifx";

export const SoundContext = createContext();

export const SoundProvider = ({ children }) => {
  const [isMuted, setIsMuted] = useState(false);

  // Preload all sounds
  const sounds = {
    success: new UIfx(successSoundFile),
    error: new UIfx(errorSoundFile),
    click: new UIfx(clickSoundFile),
  };

  const playSound = (type) => {
    if (!isMuted && sounds[type]) {
      sounds[type].play();
    }
  };

  return (
    <SoundContext.Provider value={{ isMuted, setIsMuted, playSound }}>
      {children}
    </SoundContext.Provider>
  );
};